import React, { useEffect } from 'react';

import { connect } from 'dva';
import router from 'umi/router';
import styles from './index.less';
import paySuccess from 'images/pay_success.png';
import payFail from 'images/pay_fail.png';
import { btnBackgroundColor } from 'utils/theme';
import homePage from 'utils/homePage.js';

const Status = (props = {}) => {
  // 支付成功或失败的图片和文案
  const { global } = props;
  const query = (props.location && props.location.query) || {};
  const channel = query.channel || global.channel || localStorage.getItem('channel');
  const isSuccess = query.status === 'success';
  const imgUrl = isSuccess ? paySuccess : payFail;
  const title = isSuccess ? '支付成功' : '支付失败';
  const tip = isSuccess
    ? '您的携伴次数已成功充值，请返回凭证页面查询，并继续使用携伴服务。'
    : '您的携伴次数充值失败，可返回凭证页面，再次尝试，谢谢！';

  const goHome = () => {
    const page = homePage[channel] || '/home';
    const urlParam = localStorage.getItem('urlParams');
    const query = urlParam ? JSON.parse(urlParam) : {};
    router.push({
      pathname: page,
      query,
    });
  };

  const componentWillUnmount = () => {
    // 组件销毁时你要执行的代码
    window.removeEventListener('popstate', goHome, false);
  };
  // 点击按钮
  const onClickBtn = () => {
    goHome();
  };

  if (window.history && window.history.pushState) {
    window.history.pushState(null, null, document.URL);
    window.addEventListener('popstate', goHome, false);
  }

  useEffect(() => {
    return componentWillUnmount;
  }, [componentWillUnmount]);

  return (
    <div>
      <img src={imgUrl} alt="" className={styles.payImg} />
      <div className={styles.title}>{title}</div>
      <div className={styles.tip}>{tip}</div>
      <div
        className={styles.btn}
        style={{ background: btnBackgroundColor[channel] }}
        onClick={onClickBtn}
      >
        返回凭证页
      </div>
    </div>
  );
};
export default connect(({ global }) => {
  return { global };
})(Status);
